import Amplify from "aws-amplify";

export default function ConfigureAmplify() {
  Amplify.configure({
    Auth: {
      mandatorySignIn: false,
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID
    },
    Storage: {
      region: process.env.REACT_APP_S3_STORE_REGION,
      bucket: process.env.REACT_APP_S3_STORE_BUCKET,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
    },
    API: {
      endpoints: [
        {
          region: process.env.REACT_APP_API_GATEWAY_REGION,
          name: process.env.REACT_APP_API_GATEWAY_NAME,
          endpoint: process.env.REACT_APP_API_GATEWAY_URL
        }
      ]
    }
  });
};



// WEBPACK FOOTER //
// ./src/configs/aws_amplify_config.js